import { render } from "./ConfigurationForms.vue?vue&type=template&id=f1252436&scoped=true"
import script from "./ConfigurationForms.vue?vue&type=script&lang=js"
export * from "./ConfigurationForms.vue?vue&type=script&lang=js"

import "./ConfigurationForms.vue?vue&type=style&index=0&id=f1252436&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1252436"]])

export default __exports__